<script>
  import { getContext, onMount } from 'svelte';
  import { fade, fly } from 'svelte/transition';
 
  import {SEARCH_PROGRAMS} from '../../graphql/programs';
  
  const client = getContext('apollo');

  import Loader from '../../components/ui/loader.html';
  import Program from './components/program.html';
  import Search from '../../components/inputs/search';
  import CoordinatorInput from '../../components/inputs/coordinator';
  import TextInput from '../../components/inputs/text';
  import Form from '../../components/inputs/form';
  import Plus from '../../components/buttons/plus';
  import Link from '../../utils/link';
  import LoadMore from '../../components/buttons/loadmore';
  import SectionNav from '../../components/navigation/section'

  let search = '';
  let coordinator = null;
  let query = client.watchQuery({ query: SEARCH_PROGRAMS, variables: {}, fetchPolicy: 'network-only' });
  let results = {loading: true};

  function setResponse({data, loading, error, networkStatus}) {
    results = {
      loading,
      page: data && data.programs ? data.programs.page : 1,
      pages: data && data.programs ? data.programs.pages : 1,
      total: data && data.programs ? data.programs.total : 0,
      programs: data && data.programs ? data.programs.docs : []
    }
  }

  const subscription = query.subscribe({
    next: nextResult => {
      setResponse(nextResult);
    },
    error: error => {
      setResponse({error, loading: false});
    }
  });

  function searchPeople() {
    const response = query.refetch({search:{name: search, coordinator: coordinator}, page: 1});
  }

  function loadMore() {
    query.fetchMore({
      variables: {
        search:{name: search, coordinator: coordinator},
        page: results.page + 1
      },
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return Object.assign({}, prev, {
          programs: {
            ...fetchMoreResult.programs,
            docs: [...prev.programs.docs, ...fetchMoreResult.programs.docs]
          }
        });
      }
    });
  }
</script>


<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-6">
    <h1>{results.total || 0} Programs</h1>
  </div>
  <div class="cell small-12 medium-6 text-right">
    <Link href="/programs/new">
      <Plus label="ADD PROGRAM" ></Plus>
    </Link>
  </div>
</div>

<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-9">
    {#if results.loading}
      <Loader></Loader>
    {/if}
    {#if !results.loading}
      <div class="grid-x grid-margin-x small-up-1 medium-up-2">
        {#each results.programs as program (program.id)}
          <div class="cell">
            <Program program="{program}" ></Program>
          </div>
        {/each}
      </div>
    {/if}
    <div class="text-center">
      {#if !results.loading && results.page !== results.pages}
        <LoadMore on:click={loadMore} ></LoadMore>
      {/if}
    </div>
  </div>
  
  <div class="cell small-12 medium-3">
    <SectionNav>
      <Form>
        <div class="grid-x grid-margin-x">
          <div class="cell small-12 medium-12">
            <div class="form-group">
              <TextInput 
                on:input="{searchPeople}" 
                bind:value={search} 
                label="Program Name"
                placeholder="Search Programs"
              ></TextInput>
            </div>
          </div>
          <div class="cell small-12 medium-12">
            
              <CoordinatorInput 
                bind:value={coordinator} 
                on:change="{searchPeople}" 
                label="Coordinator" 
                placeholder="Program Coordinator" 
              ></CoordinatorInput>
            
          </div>
        </div>
      </Form>
    </SectionNav>
  </div>
 
</div>
